import { Plus } from 'lucide-react';

import { notifySuccess } from '@/portainer/services/notifications';
import { pluralize } from '@/portainer/helpers/strings';

import { DeleteButton } from '@@/buttons/DeleteButton';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';

import { Policy } from '../../types';
import { useDeletePoliciesMutation } from '../../queries/useDeletePoliciesMutation';

export function TableActions({ selectedItems }: { selectedItems: Policy[] }) {
  const deleteMutation = useDeletePoliciesMutation();

  return (
    <>
      <DeleteButton
        disabled={selectedItems.length === 0}
        confirmMessage={`Are you sure you want to remove the selected ${pluralize(
          selectedItems.length,
          'policy',
          'policies'
        )}?`}
        onConfirmed={handleRemove}
        data-cy="remove-policies-button"
      />

      <Button
        as={Link}
        icon={Plus}
        data-cy="create-policy-button"
        props={{
          to: '.create',
        }}
      >
        Create Policy
      </Button>
    </>
  );

  function handleRemove() {
    const ids = selectedItems.map((item) => item.Id);
    deleteMutation.mutate(ids, {
      onSuccess() {
        notifySuccess(
          'Success',
          `${pluralize(selectedItems.length, 'Policy', 'Policies')} removed`
        );
      },
    });
  }
}
